import { Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";

import TimelineLogs from "components/TimelineLogs";
import { HistoricoEquipamentoLogs } from "core/features/equipamento/typings/index";

interface HistoricoProps {
  logs: HistoricoEquipamentoLogs[];
}

function Historico({ logs }: HistoricoProps) {
  return (
    <Flex flexDir="column">
      <Text fontSize={20} mb={1}>
        Histórico
      </Text>
      {logs.map((log, index) => (
        <TimelineLogs data={log} key={index} />
      ))}
    </Flex>
  );
}

export default Historico;
